export const csldata = [
    {
      "id": "csl",
      "label": "CSL improvement",
      "variant": "root",
      "type": "L1",
      "dec": "CSL decrease is primarily due to supply chain disruption and increased demand variability",
      "children": [
        {
          "id": "supply-planning",
          "label": "Supply Planning Issues",
          "variant": "primary",
          "iconName": "trending",
          "type": "L2",
          "dec": "Delays in raw material procurement and limited production capacity impacted inventory levels.",
          "children": [
            {
              "id": "capacity-issues",
              "label": "Capacity Issues",
              "variant": "secondary",
              "iconName": "calendar",
              "type": "L3",
              "dec": "Manufacturing faced constraints due to limited co-packing and internal plant capacity.",
              "children": [
                {
                  "id": "co-pack",
                  "label": "Co-Pack/Manufacturing Capacity",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Co-packing partners experienced limitations during peak demand periods.",
                  "children": [
                    {
                      "id": "negotiate-capacity",
                      "label": "Negotiate for 10% more capacity with X or expand Co-Packing option for peak months",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Negotiating with co-packers or expanding peak month options can alleviate bottlenecks."
                    }
                  ]
                },
                {
                  "id": "internal-capacity",
                  "label": "Internal Manufacturing capacity",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Internal manufacturing lines operated below optimal levels due to outdated equipment and workforce shortages.",
                  "children": [
                    {
                      "id": "expand-capacity",
                      "label": "Expand capacity- (Capex expenditure)",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Investing in capital expansion projects can enhance capacity and reduce dependency on co-packers."
                    }
                  ]
                }
              ]
            },
            {
              "id": "quality-hold",
              "label": "Quality Hold",
              "variant": "secondary",
              "iconName": "activity",
              "type": "L3",
              "dec": "Stock held under quality review delayed dispatches and impacted service levels.",
              "children": [
                {
                  "id": "quality-check",
                  "label": "Check for number of Days of stock in Quality Hold (>7 days, investigate)",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Monitor stock in quality hold exceeding 7 days and investigate root causes for delay.",
                  "children": [
                     {
                  "id": "fast-track",
                  "label": "Coordinate with Quality team for fast-track decision",
                  "variant": "secondary",
                  "type": "L5",
                  "dec": "Engage the quality team to prioritize inspection and release of critical batches."
                }
                  ]
  
  
                }
                // ,
                // {
                //   "id": "fast-track",
                //   "label": "Coordinate with Quality team for fast-track decision",
                //   "variant": "secondary",
                //   "type": "L4",
                //   "dec": "Engage the quality team to prioritize inspection and release of critical batches."
                // }
              ]
            }
          ]
        },
        {
          "id": "logistics-issues",
          "label": "Logistics Issues",
          "variant": "primary",
          "iconName": "pie",
          "type": "L2",
          "dec": "Transportation and warehousing limitations delayed deliveries and disrupted supply flow.",
          "children": [
            {
              "id": "stock-inbound",
              "label": "Stock Inbound Delays",
              "variant": "secondary",
              "type": "L3",
              "dec": "Port congestion and customs issues delayed inbound shipments, affecting production.",
              "children": [
                {
                  "id": "rec-arrival",
                  "label": "Rec Arrival and Planned Arrival",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Significant delays between recommended and planned arrival dates disrupted production schedules.",
  
                  "children": [
                {
                  "id": "expedite-delivery",
                  "label": "Expedite delivery of Baxtors Stock",
                  "variant": "secondary",
                  "type": "L5",
                  "dec": "Prioritize transport and clearance of delayed Baxtors stock to restore supply continuity."
                }
              ]
                }
              ]
            },
            {
              "id": "warehouse-space",
              "label": "Warehouse Space capacity issues",
              "variant": "secondary",
              "type": "L3",
              "dec": "Warehouse utilization reached critical levels, causing order staging and storage delays.",
              "children": [
                {
                  "id": "warehouse-utilization",
                  "label": "Warehouse Capacity utilization",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "High space utilization reduced operational efficiency and increased handling time.",
                  "children": [
                    {
                      "id": "increase-space",
                      "label": "Increase warehouse space by 20%",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Expanding warehouse capacity can relieve congestion and enable smoother operations."
                    },
                    {
                      "id": "rotate-orders",
                      "label": "Rotate orders to have even order phasing throughout the month",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Balancing order scheduling across the month helps optimize warehouse utilization."
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "other-reason",
          "label": "Other Reason",
          "variant": "primary",
          "iconName": "globe",
          "type": "L2",
          "dec": "External and strategic factors contributed to material shortages and stockouts.",
          "children": [
            {
              "id": "raw-material",
              "label": "Raw Material & Packaging Material availability",
              "variant": "secondary",
              "type": "L3",
              "dec": "Supplier constraints and transportation issues led to raw and packaging material shortages.",
              "children": [
                {
                  "id": "check-requirements",
                  "label": "Check for requirement vs forecasted Raws & Packs availability",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Compare forecasted demand with supplier commitments to identify potential shortfalls.",
                  "children": [
                    {
                      "id": "prepone-delivery",
                      "label": "Prepone delivery date of Raws & Packs order (PO22893)",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Advance delivery of key material orders to ensure timely production start."
                    }
                  ]
  
                }
                
              ]
            },
            {
              "id": "strategic-decision",
              "label": "Strategic Decision",
              "variant": "secondary",
              "type": "L3",
              "dec": "Strategic business choices like product rationalization and pricing impacted supply.",
              "children": [
                {
                  "id": "profitability",
                  "label": "Profitability of the Stock",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Low-margin products were deprioritized, impacting stock availability.",
                  "children": [
                    {
                      "id": "increase-price",
                      "label": "Check with Finance team to increase product price",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Revising product pricing improves margin sustainability and supports continued production."
                    }
                  ]
                },
                {
                  "id": "product-sunset",
                  "label": "Product Sunset",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "End-of-life product decisions led to reduced production and stock levels.",
                  "children": [
                    {
                      "id": "prebuild-avoid-stockout",
                      "label": "Check with leadership on pre-build to avoid stockout",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Coordinate pre-builds before product phase-out to maintain adequate supply during transition."
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
]



export const gsv = [
    {
      "id": "gsv",
      "label": "GSV",
      "variant": "root",
      "type": "L1",
      "dec": "Gross Sales Value (GSV) represents the total sales generated before deductions such as discounts and taxes, serving as a key metric for revenue performance.",
      "children": [
        {
          "id": "time-series",
          "label": "Time Series Analysis",
          "variant": "primary",
          "iconName": "trending",
          "type": "L2",
          "dec": "Analyzes sales trends over time to identify growth patterns, seasonal effects, and long-term performance shifts.",
          "children": [
            {
              "id": "ytd",
              "label": "YTD Variance",
              "variant": "secondary",
              "iconName": "calendar",
              "type": "L3",
              "dec": "Measures the difference between current year-to-date performance and the same period in the previous year."
            },
            {
              "id": "mom",
              "label": "Month on Month",
              "variant": "secondary",
              "iconName": "activity",
              "type": "L3",
              "dec": "Compares monthly sales changes to detect short-term fluctuations or emerging trends."
            },
            {
              "id": "stats",
              "label": "Statistical Analysis",
              "variant": "secondary",
              "iconName": "chart",
              "type": "L3",
              "dec": "Applies statistical models such as regression or correlation to understand key performance drivers."
            },
            {
              "id": "rolling",
              "label": "Rolling Average",
              "variant": "secondary",
              "iconName": "trending",
              "type": "L3",
              "dec": "Smooths out volatility by averaging performance over a defined rolling period (e.g., 3 or 6 months)."
            },
            {
              "id": "cagr",
              "label": "CAGR",
              "variant": "secondary",
              "iconName": "calculator",
              "type": "L3",
              "dec": "Calculates the compound annual growth rate, showing the average yearly growth over a period."
            }
          ]
        },
        {
          "id": "decomposition",
          "label": "Decomposition Analysis",
          "variant": "primary",
          "iconName": "pie",
          "type": "L2",
          "dec": "Breaks down sales changes into contributing factors like volume, pricing, and mix to identify growth sources.",
          "children": [
            {
              "id": "volume",
              "label": "Volume- PriceMix",
              "variant": "secondary",
              "iconName": "chart",
              "type": "L3",
              "dec": "Analyzes how changes in volume and pricing contributed to overall sales performance."
            },
            {
              "id": "accounting",
              "label": "Accounting Mix (% Breakdown)",
              "variant": "secondary",
              "iconName": "calculator",
              "type": "L3",
              "dec": "Shows sales distribution across accounting categories to identify high and low-performing areas."
            },
            {
              "id": "product",
              "label": "Product Mix (% Breakdown)",
              "variant": "secondary",
              "iconName": "package",
              "type": "L3",
              "dec": "Evaluates how product portfolio composition affects total sales and profitability."
            },
            {
              "id": "segment",
              "label": "Segment Mix (% Breakdown)",
              "variant": "secondary",
              "iconName": "pie",
              "type": "L3",
              "dec": "Assesses sales contribution across customer or market segments to guide strategic focus."
            }
          ]
        },
        {
          "id": "internal",
          "label": "Benchmarking against internal factors",
          "variant": "primary",
          "iconName": "target",
          "type": "L2",
          "dec": "Compares current GSV performance against internal benchmarks like production output, supply efficiency, and historical baselines."
        },
        {
          "id": "macro",
          "label": "Benchmarking with macro- economic factors",
          "variant": "primary",
          "iconName": "globe",
          "type": "L2",
          "dec": "Examines how external macroeconomic indicators correlate with sales performance.",
          "children": [
            {
              "id": "inflation",
              "label": "Inflationary Trend",
              "variant": "secondary",
              "iconName": "trending",
              "type": "L3",
              "dec": "Assesses how inflation impacts product pricing, purchasing power, and overall sales growth."
            },
            {
              "id": "fx",
              "label": "FX Fluctuations and Trend",
              "variant": "secondary",
              "iconName": "dollar",
              "type": "L3",
              "dec": "Analyzes how currency exchange rate movements affect revenue and import/export margins."
            },
            {
              "id": "sector",
              "label": "Sector Growth",
              "variant": "secondary",
              "iconName": "chart",
              "type": "L3",
              "dec": "Benchmarks company performance against broader sectoral growth trends."
            }
          ]
        },
        {
          "id": "competitors",
          "label": "Benchmarking against competitors",
          "variant": "primary",
          "iconName": "users",
          "type": "L2",
          "dec": "Compares GSV performance with competitors to assess market position and identify improvement areas.",
          "children": [
            {
              "id": "advertising",
              "label": "Advertising & Promotion",
              "variant": "secondary",
              "iconName": "megaphone",
              "type": "L3",
              "dec": "Evaluates promotional spending effectiveness versus competitors to gauge market impact."
            },
            {
              "id": "trade",
              "label": "Trade expenditure",
              "variant": "secondary",
              "iconName": "cart",
              "type": "L3",
              "dec": "Analyzes trade spending patterns and discount strategies to optimize channel profitability."
            }
          ]
        }
      ]
    }
  ]
  
export const stoke = [
    {
      "id": "root",
      "label": "High Days of Stock",
      "variant": "root",
      "type": "L1",
      "dec": "Identifies potential factors contributing to high inventory levels.",
      "children": [
        {
          "id": "supply-planning",
          "label": "Supply Planning",
          "variant": "primary",
          "type": "L2",
          "dec": "Evaluates planning and production processes that may cause excess stock.",
          "children": [
            {
              "id": "increase-stock",
              "label": "Increase the stock days for prebuild",
              "variant": "secondary",
              "type": "L3",
              "dec": "Higher prebuild buffer could result in excess inventory.",
              "children": [
                {
                  "id": "check-stock-days",
                  "label": "Check for Last year and this year days of stock",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Compare stock days trend to identify anomalies or seasonality.",
                  "children": [
                    {
                      "id": "change-prod-plan",
                      "label": "Change the production plan if there are any anomalies",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Adjust the production schedule to correct deviations in stock days."
                    }
                  ]
                }
              ]
            },
            {
              "id": "over-production",
              "label": "Over production issue",
              "variant": "secondary",
              "type": "L3",
              "dec": "Overproduction relative to demand increases stock levels.",
              "children": [
                {
                  "id": "check-prod-plan",
                  "label": "Check production plan vs actual",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Compare planned vs. actual production to identify excess manufacturing.",
                  "children": [
                    {
                      "id": "change-future-plan",
                      "label": "Change the future production plan",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Revise upcoming production plans to align with accurate forecasts."
                    }
                  ]
                }
              ]
            },
            {
              "id": "wrong-plan",
              "label": "Wrong production Plan followed",
              "variant": "secondary",
              "type": "L3",
              "dec": "Production executed against incorrect planning assumptions.",
              "children": [
                {
                  "id": "check-prod-plan-follow",
                  "label": "Check production plan vs actual",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Verify adherence to approved production schedules.",
                  "children": [
                    {
                      "id": "apply-automation",
                      "label": "Apply process automation to increase production plan adherence",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Introduce automated planning tools to reduce manual errors."
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "demand-gen",
          "label": "Demand Generation (Sales/Demand)",
          "variant": "primary",
          "type": "L2",
          "dec": "Analyzes demand-side factors impacting stock levels.",
          "children": [
            {
              "id": "low-demand",
              "label": "Lower Demand than predicted (High Bias)",
              "variant": "secondary",
              "type": "L3",
              "dec": "Actual sales were lower than forecasts, resulting in excess stock.",
              "children": [
                {
                  "id": "check-marketing",
                  "label": "Check for marketing spent for the brand",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Assess if marketing spend aligned with sales projections.",
                  "children": [
                    {
                      "id": "increase-visibility",
                      "label": "Increase Brand visibility by marketing",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Enhance marketing activities to stimulate demand."
                    }
                  ]
                },
                {
                  "id": "check-availability",
                  "label": "Check for brand availability",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Ensure stock availability in key markets and outlets.",
                  "children": [
                    {
                      "id": "retail-push",
                      "label": "Check for retail sales and push for product at places where there is shortage",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Redistribute stock to low-supply regions to balance inventory."
                    }
                  ]
                }
              ]
            },
            {
              "id": "order-cancel",
              "label": "Order Cancellation/ return by customer",
              "variant": "secondary",
              "type": "L3",
              "dec": "Customer order cancellations or returns inflated inventory.",
              "children": [
                {
                  "id": "check-cancel-reason",
                  "label": "Check reason of order cancellation/ return",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Investigate causes of cancellation or return patterns.",
                  "children": [
                    {
                      "id": "incentivize",
                      "label": "Incentivize customer to reduce the return",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Offer loyalty benefits or discounts to discourage returns."
                    },
                    {
                      "id": "improve-service",
                      "label": "Improve customer service to reduce return",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Enhance post-purchase support and responsiveness."
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "logistics",
          "label": "Logistics",
          "variant": "primary",
          "type": "L2",
          "dec": "Covers transportation and delivery challenges affecting inventory flow.",
          "children": [
            {
              "id": "transport-delay",
              "label": "Transportation delay issues",
              "variant": "secondary",
              "type": "L3",
              "dec": "Late deliveries disrupt planned inventory turnover.",
              "children": [
                {
                  "id": "check-on-time",
                  "label": "Check for On time delivery",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Analyze on-time delivery metrics to pinpoint bottlenecks.",
                  "children": [
                    {
                      "id": "improve-visibility",
                      "label": "Improve visibility of delayed shipment and follow-up to expedite its delivery",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Enhance shipment tracking and communication with carriers."
                    },
                    {
                      "id": "penalize-3pl",
                      "label": "Penalize the 3PLs for delay in delivery",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Implement SLA penalties for logistics partners failing on delivery timelines."
                    }
                  ]
                }
              ]
            }
          ]
        },
        {
          "id": "strategic-decision",
          "label": "Strategic decision",
          "variant": "primary",
          "type": "L2",
          "dec": "Evaluates strategic pricing and policy choices affecting inventory.",
          "children": [
            {
              "id": "price-increase",
              "label": "Price Increase",
              "variant": "secondary",
              "type": "L3",
              "dec": "Recent price hikes may have suppressed demand.",
              "children": [
                {
                  "id": "check-correlation",
                  "label": "Check for correlation between price and sales",
                  "variant": "secondary",
                  "type": "L4",
                  "dec": "Assess elasticity of sales relative to pricing changes.",
                  "children": [
                    {
                      "id": "offer-discount",
                      "label": "Offer discounts and phase out increase in pricing",
                      "variant": "secondary",
                      "type": "L5",
                      "dec": "Implement short-term discounts to normalize sales volume."
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
  
  